import { produce } from 'immer';
import { STATUS_FAILED, STATUS_PENDING, STATUS_SUCCESS } from 'Common/constants/commonConstants';
import * as HomePageConstants from './HomePageConstants';

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    isDevicesDataFetching: false,
    isDevicesDataFetched: false,
    isDevicesDataFetchFailed: false,
    devicesAuthorized: [],
    devicesPreferred: [],
    userPreferenceExists: undefined,
    userPreferenceSavedCount: 0,
    isReportIDFetching: false,
    isReportIDFetched: false,
    isWorkSpaceIDFetching: false,
    isWorkSpaceIDFetched: false,
    isFetchingFailed: false,
    errorSaveUserPreferenceModal: false,
    isHomePageListViewFetching: false,
    isHomePageListViewFetched: false,
    homePageListViewData: [],
    isHomePageListViewFetchedFailed: false,
    hasMore: false,
    nextCursor: null,
    isLoadingMore: false,
    filterOptions: {
        incidents: [],
        models: [],
        cities: [],
        countries: [],
        customers: [],
        serialNumbers: []
    },
    countHomePageCritical: undefined,
    countHomePageWarning: undefined,
    countTotalPatientTest: undefined,
    connectionRatePercentage:undefined,
    watchlistActionStatus: STATUS_SUCCESS, // STATUS_SUCCESS -> STATUS_PENDING -> STATUS_FAILED
    watchlistAccessDenied: false
}

export default function HomePageReducer(state = initialState, action) {

    switch (action.type) {

        case HomePageConstants.GET_ALL_DEVICES_FOR_USER_REQUEST:
            return assign({}, state, {
                isDevicesDataFetching: true,
                isDevicesDataFetched: false,
                isDevicesDataFetchFailed: false
            });
            break;

        case HomePageConstants.GET_ALL_DEVICES_FOR_USER_SUCCESS:
            return assign({}, state, {
                isDevicesDataFetching: false,
                isDevicesDataFetched: true,
                isDevicesDataFetchFailed: false,
                devicesPreferred: action.newState.result.preferredDevices,
                devicesAuthorized: action.newState.result.allowedDevices,
                userPreferenceExists: action.newState.result.userPreferenceExists
            });
            break;

        case HomePageConstants.GET_ALL_DEVICES_FOR_USER_FAILURE:
            return assign({}, state, {
                isDevicesDataFetching: false,
                isDevicesDataFetched: false,
                isDevicesDataFetchFailed: true
            });
            break;
        case HomePageConstants.RESET_DEVICES_DATA_FETCH_FAILED_FLAG: {
            return assign({}, state, {
                isDevicesDataFetching: false,
                isDevicesDataFetched: false,
                isDevicesDataFetchFailed: false
            });
        }
        case HomePageConstants.ERROR_SAVE_USER_PREFERENCE_MODAL:
            return assign({}, state, {
                errorSaveUserPreferenceModal: action.newState.errorSaveUserPreferenceModal
            });
            break;
        case HomePageConstants.HOME_PAGE_USER_PREFERENCE_SAVED:
            return assign({}, state, {
                userPreferenceSavedCount: state.userPreferenceSavedCount + 1
            });
            break;
        case HomePageConstants.HOME_PAGE_REPORT_ID_API_REQUEST:
            return assign({}, state, {
                isReportIDFetching: true,
                isReportIDFetched: false
            });
            break;
        case HomePageConstants.HOME_PAGE_REPORT_ID_API_SUCCESS:
            {
                return assign({}, state, {
                    isReportIDFetching: false,
                    isReportIDFetched: true,
                    reportID: action.newState
                });
            }
            break;
        case HomePageConstants.HOME_PAGE_REPORT_ID_API_FAILURE:
            return assign({}, state, {
                isReportIDFetching: false,
                isReportIDFetched: false,
                isFetchingFailed: true
            });
            break;
        case HomePageConstants.HOME_PAGE_GROUP_ID_API_REQUEST:
            return assign({}, state, {
                isWorkSpaceIDFetching: true,
                isWorkSpaceIDFetched: false
            });
            break;
        case HomePageConstants.HOME_PAGE_GROUP_ID_API_SUCCESS:
            {
                return assign({}, state, {
                    isWorkSpaceIDFetching: false,
                    isWorkSpaceIDFetched: true,
                    workSpaceID: action.newState
                });
            }
            break;
        case HomePageConstants.HOME_PAGE_GROUP_ID_API_FAILURE:
            return assign({}, state, {
                isWorkSpaceIDFetching: false,
                isWorkSpaceIDFetched: false,
                isFetchingFailed: true
            });
            break;
        case HomePageConstants.HOME_PAGE_LIST_VIEW_API_REQUEST:
            return assign({}, state, {
                isHomePageListViewFetching: true,
                isHomePageListViewFetched: false,
                isHomePageListViewFetchedFailed: false
            });
            break;
        case HomePageConstants.HOME_PAGE_LIST_VIEW_API_SUCCESS:
            {
                return assign({}, state, {
                    isHomePageListViewFetching: false,
                    isHomePageListViewFetched: true,
                    homePageListViewData: action.newState.result.data || [],
                    hasMore: action.newState.result.hasMore || false,
                    nextCursor: action.newState.result.nextCursor || null,
                    isHomePageListViewFetchedFailed: false
                });
            }
            break;

        case HomePageConstants.HOME_PAGE_DROPDOWN_LIST_SUCCESS:
            return assign({}, state, {
                filterOptions: action.filterOptions
            });
            break;

        case HomePageConstants.HOME_PAGE_DROPDOWN_LIST_REQUEST:
        case HomePageConstants.HOME_PAGE_DROPDOWN_LIST_FAILURE:
            return state;
        case HomePageConstants.HOME_PAGE_LIST_VIEW_LOAD_MORE_REQUEST:
            return assign({}, state, {
                isLoadingMore: true
            });
            break;
        case HomePageConstants.HOME_PAGE_LIST_VIEW_LOAD_MORE:
            {
                return assign({}, state, {
                    isLoadingMore: false,
                    isHomePageListViewFetched: true,
                    homePageListViewData: [...state.homePageListViewData, ...(action.newState.result.data || [])],
                    hasMore: action.newState.result.hasMore || false,
                    nextCursor: action.newState.result.nextCursor || null,
                    isHomePageListViewFetchedFailed: false
                });
            }
            break;
        case HomePageConstants.HOME_PAGE_LIST_VIEW_LOAD_MORE_FAILURE:
            // Stop the spinner but keep existing rows visible
            return assign({}, state, {
                isLoadingMore: false,
                hasMore: false
            });
            break;
        case HomePageConstants.HOME_PAGE_LIST_VIEW_API_FAILURE:
            return assign({}, state, {
                isHomePageListViewFetching: false,
                isHomePageListViewFetched: false,
                isHomePageListViewFetchedFailed: true
            });
            break;

        case HomePageConstants.HOME_PAGE_CRITICAL_COUNT:
            return assign({}, state, {
                countHomePageCritical: action.newState.countHomePageCritical
            });
            break;

        case HomePageConstants.HOME_PAGE_WARNING_COUNT:
            return assign({}, state, {
                countHomePageWarning: action.newState.countHomePageWarning
            });
            break;

        case HomePageConstants.HOME_PAGE_PATIENT_TEST_COUNT:
            return assign({}, state, {
                countTotalPatientTest: action.newState.countTotalPatientTest
            });
            break;
        case HomePageConstants.HOME_PAGE_CONNECTION_RATE:
            return assign({}, state, {
                connectionRatePercentage: action.newState.connectionRatePercentage
            });
            break;
        case HomePageConstants.HOME_PAGE_WATCHLIST_ACTION_REQUEST:
            return assign({}, state, {
                watchlistActionStatus: STATUS_PENDING
            });
        case HomePageConstants.HOME_PAGE_WATCHLIST_ACTION_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft.watchlistActionStatus = STATUS_SUCCESS;
                const updatedItemIndex = draft.homePageListViewData.findIndex(item => item.instance === action.payload.instanceId);
                
                if(updatedItemIndex !== -1) {
                    const updatedItem = {
                        ...draft.homePageListViewData[updatedItemIndex],
                        isWatchListedByUser: action.payload.isWatchListedByUser
                    };
                    draft.homePageListViewData = [
                        ...draft.homePageListViewData.slice(0, updatedItemIndex),
                        updatedItem,
                        ...draft.homePageListViewData.slice(updatedItemIndex+1)
                    ];
                }
            });

            return assign({}, state, newState);
        }
        case HomePageConstants.HOME_PAGE_WATCHLIST_ACTION_FAILED:
            return assign({}, state, {
                watchlistActionStatus: STATUS_FAILED
            });
        case HomePageConstants.HOME_PAGE_WATCHLIST_ACCESS_DENIED:
            return assign({}, state, {
                watchlistActionStatus: STATUS_SUCCESS, // setting it to STATUS_FAILED will cause the ErrorComponent popup to show
                watchlistAccessDenied: action.payload 
            });
        case HomePageConstants.HOME_PAGE_WATCHLIST_RESET_ACTION_STATUS:
            return assign({}, state, {
                watchlistActionStatus: STATUS_SUCCESS
            });
        default:
            return state;

    }

}